import Bowser from 'bowser';
export const isPWA = () => window.matchMedia('(display-mode: standalone)').matches;
export const isDesktop = () => Bowser.getParser(navigator.userAgent).getPlatformType() === 'desktop';
export const isWLA = () => window.__fw_app__.mobileSession;
export const isSafari = () => Bowser.getParser(navigator.userAgent).getBrowserName() === 'Safari';
export const isProduction = () => window.__fw_app__.environment === 'production';
export const isDevelopment = () => window.__fw_app__.environment === 'development';
export const getCsrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content;
